module.exports = __webpack_public_path__ + "img/tzone_only.241d13db.svg";